import { jsxs as t, jsx as C } from "react/jsx-runtime";
function e(i) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "40", viewBox: "0 0 135 40", width: "135", xmlns: "http://www.w3.org/2000/svg", ...i, children: [
    /* @__PURE__ */ t("g", { clipPath: "url(#clip0_2337_22533)", children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M130.051 0H4.94294C2.17851 0 -0.0625 2.23889 -0.0625 5.0007V34.9993C-0.0625 37.7611 2.17851 40 4.94294 40H130.051C132.815 40 135.056 37.7611 135.056 34.9993V5.0007C135.056 2.23889 132.815 0 130.051 0Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M130.056 0.801467C132.373 0.801467 134.26 2.68661 134.26 5.0007V34.9993C134.26 37.3134 132.373 39.1985 130.056 39.1985H4.94294C2.62665 39.1985 0.739726 37.3134 0.739726 34.9993V5.0007C0.739726 2.68661 2.62665 0.801467 4.94294 0.801467H130.056ZM130.056 0H4.94294C2.19164 0 -0.0625 2.25201 -0.0625 5.0007V34.9993C-0.0625 37.748 2.19164 40 4.94294 40H130.056C132.808 40 135.062 37.748 135.062 34.9993V5.0007C135.062 2.25201 132.808 0 130.056 0Z",
          fill: "#A6A6A6"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M47.3996 10.2441C47.3996 11.0795 47.151 11.7511 46.6538 12.2478C46.0889 12.8404 45.3545 13.1339 44.4505 13.1339C43.5466 13.1339 42.8461 12.8348 42.2416 12.2365C41.6371 11.6382 41.332 10.8932 41.332 10.0014C41.332 9.10965 41.6371 8.37027 42.2416 7.76634C42.8461 7.16806 43.5862 6.86328 44.4505 6.86328C44.8799 6.86328 45.2923 6.94794 45.6821 7.11162C46.0719 7.28095 46.3883 7.50107 46.6199 7.78328L46.0945 8.31382C45.6991 7.83972 45.1511 7.60266 44.4505 7.60266C43.8178 7.60266 43.2698 7.82278 42.8122 8.26867C42.3546 8.71456 42.123 9.29026 42.123 9.99578C42.123 10.7013 42.3546 11.2826 42.8122 11.7229C43.2754 12.1688 43.8178 12.3889 44.4505 12.3889C45.1228 12.3889 45.6821 12.1631 46.1284 11.7172C46.4166 11.4237 46.586 11.023 46.6312 10.5038H44.4505V9.7813H47.36C47.3883 9.93934 47.3996 10.0861 47.3996 10.2328V10.2441Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M52.0152 7.73813H49.2808V9.64021H51.7496V10.3627H49.2808V12.2647H52.0152V13.0041H48.5068V7.00439H52.0152V7.74378V7.73813Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M55.2693 12.9985H54.4953V7.73816H52.8174V6.99878H56.9415V7.73816H55.2636V12.9985H55.2693Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M59.9297 12.9985V6.99878H60.698V12.9985H59.9297Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M64.1277 12.9985H63.3537V7.73816H61.6758V6.99878H65.7999V7.73816H64.122V12.9985H64.1277Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M73.6129 12.2252C73.0197 12.8347 72.2909 13.1339 71.4096 13.1339C70.5283 13.1339 69.7995 12.8291 69.2063 12.2252C68.6131 11.6213 68.3193 10.8762 68.3193 10.0014C68.3193 9.12655 68.6131 8.38152 69.2063 7.7776C69.7939 7.16804 70.5283 6.8689 71.4096 6.8689C72.2909 6.8689 73.0141 7.17368 73.6072 7.78325C74.2004 8.39281 74.4942 9.13219 74.4942 10.0014C74.4942 10.8706 74.2004 11.6213 73.6072 12.2252H73.6129ZM69.7825 11.7229C70.2289 12.1744 70.7712 12.3945 71.4153 12.3945C72.0593 12.3945 72.6016 12.1687 73.048 11.7229C73.4943 11.2713 73.7146 10.7013 73.7146 10.0014C73.7146 9.30152 73.4886 8.72582 73.048 8.27993C72.6073 7.8284 72.0593 7.60828 71.4153 7.60828C70.7712 7.60828 70.2289 7.83404 69.7825 8.27993C69.3419 8.73146 69.1159 9.30152 69.1159 10.0014C69.1159 10.7013 69.3419 11.277 69.7825 11.7229Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M75.5847 12.9985V6.99878H76.5226L79.4433 11.6665H79.4772L79.4433 10.5094V6.99878H80.2173V12.9985H79.4094L76.3531 8.10503H76.3192L76.3531 9.26208V12.9985H75.5791H75.5847Z",
          fill: "white",
          stroke: "white",
          strokeMiterlimit: "10",
          strokeWidth: "0.2"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M68.138 21.7525C65.7822 21.7525 63.867 23.5417 63.867 26.0025C63.867 28.4634 65.7878 30.2526 68.138 30.2526C70.4882 30.2526 72.409 28.4464 72.409 26.0025C72.409 23.5586 70.4882 21.7525 68.138 21.7525ZM68.138 28.5819C66.8499 28.5819 65.737 27.5208 65.737 26.0025C65.737 24.4843 66.8499 23.4232 68.138 23.4232C69.4261 23.4232 70.539 24.4673 70.539 26.0025C70.539 27.5377 69.4261 28.5819 68.138 28.5819ZM58.8164 21.7525C56.4605 21.7525 54.5454 23.5417 54.5454 26.0025C54.5454 28.4634 56.4662 30.2526 58.8164 30.2526C61.1666 30.2526 63.0874 28.4464 63.0874 26.0025C63.0874 23.5586 61.1666 21.7525 58.8164 21.7525ZM58.8164 28.5819C57.5283 28.5819 56.4153 27.5208 56.4153 26.0025C56.4153 24.4843 57.5283 23.4232 58.8164 23.4232C60.1045 23.4232 61.2174 24.4673 61.2174 26.0025C61.2174 27.5377 60.1045 28.5819 58.8164 28.5819ZM47.7264 23.0563V24.8624H52.0483C51.9184 25.8784 51.5794 26.6177 51.0653 27.137C50.4382 27.7635 49.4552 28.4577 47.7264 28.4577C45.0655 28.4577 42.9865 26.313 42.9865 23.6546C42.9865 20.9962 45.0655 18.8514 47.7264 18.8514C49.1614 18.8514 50.2122 19.4158 50.9805 20.1383L52.2573 18.8627C51.1783 17.8298 49.7433 17.0453 47.7264 17.0453C44.0825 17.0453 41.0205 20.0085 41.0205 23.6489C41.0205 27.2894 44.0825 30.2526 47.7264 30.2526C49.6925 30.2526 51.1783 29.6091 52.3364 28.4013C53.5285 27.2104 53.9013 25.5341 53.9013 24.1795C53.9013 23.7618 53.8674 23.3724 53.8053 23.0506H47.7264V23.0563ZM93.0748 24.456C92.7189 23.5078 91.6399 21.7469 89.4309 21.7469C87.222 21.7469 85.4141 23.4683 85.4141 25.9969C85.4141 28.3787 87.222 30.2469 89.6399 30.2469C91.589 30.2469 92.7189 29.056 93.1878 28.3618L91.7359 27.3966C91.25 28.1078 90.5891 28.5706 89.6399 28.5706C88.6908 28.5706 88.0129 28.136 87.5779 27.2838L93.2726 24.9301L93.0805 24.4448L93.0748 24.456ZM87.2672 25.8727C87.2163 24.2303 88.5439 23.3893 89.4931 23.3893C90.2331 23.3893 90.8659 23.7618 91.0749 24.2924L87.2672 25.8727ZM82.6402 29.9986H84.5102V17.4968H82.6402V29.9986ZM79.5782 22.7007H79.5161C79.098 22.204 78.2901 21.7525 77.2732 21.7525C75.1434 21.7525 73.1943 23.6207 73.1943 26.0195C73.1943 28.4182 75.1434 30.2582 77.2732 30.2582C78.2901 30.2582 79.0924 29.8067 79.5161 29.2931H79.5782V29.9026C79.5782 31.5281 78.7082 32.3973 77.3015 32.3973C76.1546 32.3973 75.4484 31.5733 75.1547 30.8847L73.5276 31.562C73.9965 32.6908 75.2394 34.0736 77.3015 34.0736C79.4935 34.0736 81.3465 32.7868 81.3465 29.643V22.0065H79.5726V22.7007H79.5782ZM77.4314 28.5819C76.1433 28.5819 75.0586 27.5039 75.0586 26.0195C75.0586 24.5351 76.1377 23.4232 77.4314 23.4232C78.7251 23.4232 79.7081 24.5181 79.7081 26.0195C79.7081 27.5208 78.7082 28.5819 77.4314 28.5819ZM101.837 17.4968H97.3628V29.9986H99.2328V25.2632H101.843C103.911 25.2632 105.95 23.7675 105.95 21.38C105.95 18.9925 103.916 17.4968 101.843 17.4968H101.837ZM101.882 23.5248H99.2271V19.2409H101.882C103.278 19.2409 104.069 20.3979 104.069 21.3856C104.069 22.3734 103.278 23.5304 101.882 23.5304V23.5248ZM113.424 21.7299C112.074 21.7299 110.673 22.3226 110.091 23.6433L111.752 24.3375C112.108 23.6433 112.763 23.4232 113.458 23.4232C114.424 23.4232 115.407 24.0045 115.424 25.0317V25.1616C115.085 24.9697 114.362 24.6762 113.475 24.6762C111.69 24.6762 109.871 25.6582 109.871 27.4926C109.871 29.1632 111.334 30.2413 112.978 30.2413C114.232 30.2413 114.927 29.6769 115.362 29.0221H115.424V29.9873H117.226V25.1954C117.226 22.9773 115.565 21.7356 113.424 21.7356V21.7299ZM113.204 28.5763C112.594 28.5763 111.741 28.2715 111.741 27.5152C111.741 26.55 112.803 26.1775 113.718 26.1775C114.537 26.1775 114.927 26.3525 115.424 26.5952C115.277 27.7522 114.283 28.5706 113.204 28.5706V28.5763ZM123.791 22.0008L121.65 27.4192H121.588L119.368 22.0008H117.356L120.689 29.5753L118.791 33.7914H120.74L125.876 22.0008H123.797H123.791ZM106.973 29.9986H108.843V17.4968H106.973V29.9986Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M20.6776 19.4214L10.0227 30.721C10.0227 30.721 10.0227 30.721 10.0227 30.7266C10.3504 31.9514 11.469 32.8545 12.8022 32.8545C13.3333 32.8545 13.8361 32.7077 14.2598 32.4594L14.2937 32.4368L26.2876 25.5227L20.672 19.4158L20.6776 19.4214Z",
          fill: "#EA4335"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M31.4567 17.4969H31.4454L26.2649 14.4885L20.429 19.6755L26.2818 25.5228L31.4341 22.554C32.3381 22.0686 32.9482 21.1147 32.9482 20.0198C32.9482 18.9248 32.3437 17.9822 31.4511 17.4969H31.4567Z",
          fill: "#FBBC04"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10.0169 9.27893C9.9548 9.51598 9.9209 9.76433 9.9209 10.0183V29.9873C9.9209 30.2413 9.9548 30.4896 10.0169 30.7267L21.0391 19.7149L10.0169 9.27893Z",
          fill: "#4285F4"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M20.7567 19.9971L26.2706 14.4885L14.2881 7.54618C13.8531 7.28655 13.3446 7.13416 12.8022 7.13416C11.469 7.13416 10.3504 8.03722 10.0227 9.26764L20.7567 19.9915V19.9971Z",
          fill: "#34A853"
        }
      )
    ] }),
    /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_2337_22533", children: /* @__PURE__ */ C("rect", { fill: "white", height: "40", width: "135" }) }) })
  ] });
}
export {
  e as default
};
